var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C7.03762 3 3 7.03762 3 12C3 16.9624 7.03762 21 12 21C16.9624 21 21 16.9624 21 12C21 7.03762 16.9624 3 12 3ZM11.4375 6.375C11.4375 6.06434 11.6893 5.8125 12 5.8125C12.3107 5.8125 12.5625 6.06434 12.5625 6.375V13.125C12.5625 13.4357 12.3107 13.6875 12 13.6875C11.6893 13.6875 11.4375 13.4357 11.4375 13.125V6.375ZM12 17.625C11.5922 17.6342 11.2113 17.422 11.0047 17.0703C10.798 16.7186 10.7979 16.2826 11.0044 15.9308C11.2109 15.579 11.5916 15.3665 11.9994 15.3756C12.6108 15.3891 13.0994 15.8885 13.0996 16.5C13.0997 17.1115 12.6114 17.6112 12 17.625Z",
    fill: "#CC0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationRed);
export default __webpack_public_path__ + "static/media/information-red.590ff32c6f74e320497b9d4f68fc0119.svg";
export { ForwardRef as ReactComponent };